import React from 'react';
import LegalPage from './LegalPage';
import { privacyPolicy } from './legalContent';

// Swap `privacyPolicy` for data from the API once the team provides the final text.
const PrivacyPolicyPage = () => (
  <LegalPage doc={privacyPolicy} other={{ to: '/termsofuse', label: 'terms of use' }} />
);

export default PrivacyPolicyPage;
